<div class="detail-container">
  <nb-card [nbSpinner]="loader()">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>
        @if (buildingApplication()?.baseData?.sectionText) {
          {{buildingApplication()?.baseData?.sectionText}}
        }
      </h5>
    </nb-card-header>

    <nb-card-body>
      <hau-form *ngIf="form()" [formGroup]="form()">

        <nb-tabset>
          <nb-tab [tabTitle]="baseDateTab">
            <wr-building-base-data-form formControlName="baseData"></wr-building-base-data-form>
            <wr-building-allocation-form formControlName="allocationData" [showTeamRegion]="false"></wr-building-allocation-form>
            <wr-building-access-form formControlName="accessData"></wr-building-access-form>
            <wr-building-amenity-form formControlName="amenityData"></wr-building-amenity-form>
          </nb-tab>

          <nb-tab [tabTitle]="buildingSectionTab">
            <wr-building-section-editor formControlName="buildingSections"></wr-building-section-editor>
          </nb-tab>
        </nb-tabset>

      </hau-form>
    </nb-card-body>

    @if (buildingApplication()?.status == applicationStatus.Pending) {
      <nb-card-footer>
        <button nbButton status="primary" (click)="rejectBuildingApplication()">
          Ablehnen
        </button>

        <button nbButton status="success" (click)="approveBuildingApplication()">
          Akzeptieren
        </button>
      </nb-card-footer>
    }
  </nb-card>
</div>
